import {
	ColorBackgroundHEX,
} from 'utils/color/ColorPalette'
import './boxWithBanner.scss';

interface BoxWithBannerProps {
	bannerColor?: any,
	backgroundColor?: any,
  children: JSX.Element,
}

const BoxWithBanner = ({
	bannerColor = ColorBackgroundHEX.blue.primary,
	backgroundColor = ColorBackgroundHEX.white.primary,
	children,
}: BoxWithBannerProps) => {

	return (
		<div className="box-with-banner-container">
			<div
				className="box-with-banner-side"
				style={{
					backgroundColor: bannerColor,
				}}
			/>
			<div
				className="box-with-banner-content"
				style={{
					backgroundColor: backgroundColor,
				}}
			>
				{children}
			</div>
		</div>

	);
}

export default BoxWithBanner;